<template>
  <div id="app" class="page-layout">
      <Nav :key="renderNav"  :class="currentRouteName =='home' ? 'nav-transparent': ''" />
      <router-view :key="renderRouterView" id="view-container"/>
  </div>
</template>

<script>
import Nav from './components/Nav.vue'

export default {
    name: 'App',
    components: {
        Nav
    },
    data: () => ({
        renderRouterView: 0,
        renderNav: 1
    }),
    computed: {
    currentRouteName() {
        return this.$route.name;
    }
    },
    mounted: function () {
        if (window.ethereum) {
            window.ethereum.on('accountsChanged', () => {
                this.forceRerender()
            })

            window.ethereum.on('chainChanged', () => {
                this.forceRerender()
            })
        }
    },
    methods: {
        forceRerender() {
            this.renderNav++
            this.renderRouterView++
        }
    }
}
</script>

<style lang="scss">

@import './assets/styles/main.scss';

.page-layout {
    padding-top: 80px;
    @media(max-width: 991px) {
        padding-top: 60px;
    }
}

</style>
